import { Box } from '@material-ui/core'

export const DealerPhoto = ({ data, dealer }) => {
  return (
    <Box
      minWidth={170}
      width="100%"
      height={150}
      maxHeight={200}
      position="relative"
    >
      {data.logo?.url && (
        <img
          src={dealer?.logo?.url}
          loading="lazy"
          alt="logo"
          width="100%"
          height="100%"
          style={{
            objectFit: 'contain',
            objectPosition: 'center'
          }}
        />
      )}
    </Box>
  )
}
